/* istanbul ignore file */
import amplitude from 'amplitude-js';

import { setupAmplitude, amplitudeMiddleware } from './amplitude/index';
import { setAmplitudeUserProperties } from './amplitude/utils';

const analytics = (store) => {
  const userSession = setupAmplitude();
  const amplitudeInstance = amplitude.getInstance();

  setAmplitudeUserProperties(amplitudeInstance);

  return (next) => (action) =>
    userSession && amplitudeMiddleware({
      userSession,
      amplitudeInstance,
      next,
      action,
      store,
    });
};

export default analytics;
